import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

const button = cva(
  'inline-flex items-center justify-center rounded-md font-bold uppercase tracking-widest transition-colors disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-team-blue',
  {
    variants: {
      variant: {
        primary: 'bg-team-blue text-surface-900 hover:bg-team-blue/85',
        ghost: 'bg-white/5 text-ink hover:bg-white/10',
      },
      size: {
        md: 'px-4 py-2.5 text-sm',
        lg: 'w-full px-5 py-3.5 text-sm',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof button>;

export const Button = ({ className, variant, size, ...props }: ButtonProps) => (
  <button className={cn(button({ variant, size }), className)} {...props} />
);
